export const about = {
	title: { pl: 'O aplikacji' },
	content: {
		pl: 'Moje Fizjo+ to aplikacja dedykowana osobom borykającym się z\xa0dolegliwościami bólowymi kręgosłupa, barku i\xa0biodra. Celem aplikacji jest przedstawienie ćwiczeń poprawiających elastyczność i\xa0siłę mięśni, co w\xa0połączeniu z\xa0automasażem, może złagodzić ból lub go wyeliminować.'
	},
	button: { pl: 'Pobierz' }
};
